module.exports = __webpack_public_path__ + "img/icon-md-mood-02.cf231a5e.svg";